import { transformPocket } from '@/common/integrations/menhir/employee/pockets/pockets.dto';
import { IMenhirPocket } from '@/common/integrations/menhir/employee/pockets/pockets.types';
import { menhirClient } from '@/common/integrations/menhir/menhir.client';
import { MENHIR_ENDPOINTS } from '@/common/integrations/menhir/menhir.endpoints';

export const getEmployeePockets = () =>
  menhirClient
    .get<null, { pockets: IMenhirPocket[] }>(MENHIR_ENDPOINTS.EMPLOYEE.POCKETS)
    .then((envelope) => envelope.pockets.map(transformPocket));
